import { css, LitElement, html, repeat } from '@hh/global.js';

class HHBundleStep extends LitElement {
  static properties = {
    step: { type: Object },
    currentStep: { type: Number },
    bundle: {
      type: Array
    },
    isFinished: { type: Boolean },
    type: { type: Number }
  }

  constructor() {
    super();
  }

  render() {
    console.log(this.step.products);
    return html`
      <div class="bundle-step__products">
        ${repeat(
          this.step.products.filter((product) => product.available),
            (product) => product.id,
            (product, index) => html`<hh-bundle-product
              .product="${product}"
              .maxStepQty="${this.step.quantity}"
              .bundle="${this.bundle}"
              .currentStep="${this.currentStep}"
              .isDisabled="${this.isFinished}"
              .type="${this.type}"
            >
            </hh-bundle-product>`
        )}
      </div>
    `
  }

  static styles = css`
    .bundle-step__products {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: var(--hh-spacing-sm);
    }

    @media (min-width: 1024px) {
      .bundle-step__products {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  `
}

if (!customElements.get('hh-bundle-step')) {
  customElements.define('hh-bundle-step', HHBundleStep);
}